export default "__VITE_ASSET__CpgFLOdv__"